import axios from 'axios';
import { RentContract } from '../models/RentContract';
import {getToken} from "../auth/service/authService";
import {BackendUrl} from "../util/config";

const API_BASE = BackendUrl;
export async function getRentContractsByOrganization(orgId: string): Promise<RentContract[]> {
    try {
        const token = getToken(); // or localStorage.getItem('jwt'), etc.

        const response = await axios.get<RentContract[]>(

            `${API_BASE}/rent-contracts/organization/${orgId}`,
            {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: token ? `Bearer ${token}` : '',
                },
            }
        );


        return response.data; // array of rent contracts
    } catch (err) {
        console.error('Error fetching rent contracts for org', orgId, err);
        throw err;
    }
}

/**
 * Filters a list of RentContracts to include only those that are "active."
 * A contract is active if the current date is between startDate and endDate (inclusive).
 *
 * @param contracts - The list of rent contracts to filter.
 * @returns A new array containing only the active RentContract objects.
 */
export function filterActiveRentContracts(contracts: RentContract[] | null): RentContract[] | null {
    const now = new Date();

    if(!contracts){
        return null
    }

    return contracts.filter((contract) => {
        const start = new Date(contract.startDate);
        const end = new Date(contract.endDate);

        // Check if now is between start and end, inclusive
        return now >= start && now <= end;
    });
}
